import React, { useEffect, useState } from "react";
import { useGetApi } from "../Api/useGetApi";

const Banner = () => {
  const [data, setData] = useState([]);

  const BannerApiCall = useGetApi();
  useEffect(() => {
    const getData = async () => {
      const response = await BannerApiCall(process.env.REACT_APP_BANNER);
      const { iterations, title } = response.msg[0];
      // console.log(iterations, title);
      const arr = Array.from({ length: iterations }, () => title);
      setData(arr);
    };
    getData();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <div className="banner-container font-fam">
        {data.map((val, index) => (
          <div className="banner-text" key={index}>
            <b>{val}</b>
          </div>
        ))}
      </div>
    </>
  );
};

export default Banner;
